import { cn } from 'cn';
import { forwardRef, type ReactNode } from 'react';

import { Icon, type IconMetaphor } from './Icon';

type P = {
  readonly icon?: IconMetaphor;
  readonly size?: 'sm' | 'md';
  readonly text: ReactNode;
} & ComponentStyling;

export const Badge = forwardRef(
  ({ className, icon, size = 'sm', style, text }: P, ref) => (
    <div
      ref={ref}
      className={cn(
        'absolute min-w-4 rounded-full bg-tiga-surface-darkest text-center text-white shadow-sm',
        {
          '-top-1.5 -right-1 h-4 px-1! text-xs leading-4': size === 'sm',
          '-top-4 -right-2.5 h-7 px-3 text-base leading-7': size === 'md',
          'flex items-center gap-1': icon,
        },
        className,
      )}
      style={style}
    >
      {icon ? <Icon metaphor={icon} /> : null}
      {text}
    </div>
  ),
);
